import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Phone, Mail, MessageCircle } from "lucide-react";
import api from "@/api";
import { useStore } from "@/store/StoreContext";
import Seo from "@/components/store/Seo";

export default function CmsPage() {
  const { slug } = useParams();
  const { settings } = useStore();
  const [page, setPage] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    setPage(null); setError(false);
    api.get(`/pages/${slug}`).then(({ data }) => setPage(data)).catch(() => setError(true));
  }, [slug]);
  if (error) return (
    <div className="tq-container py-24 text-center">
      <h1 className="font-serif text-4xl mb-4">Page not found</h1>
      <Link to="/" className="tq-btn-dark">Back to Home</Link>
    </div>
  );
  if (!page) return <div className="tq-container py-16 max-w-3xl"><div className="h-8 bg-[#FAFAFA] animate-pulse w-1/2 mb-6" /><div className="h-48 bg-[#FAFAFA] animate-pulse" /></div>;
  const store = settings?.store || {};
  return (
    <div className="tq-container py-12 sm:py-16 max-w-3xl" data-testid={`cms-page-${slug}`}>
      <Seo title={page.seo?.title?.replace(" | TARISHQ FASHION", "") || page.title} description={page.seo?.description || page.excerpt} />
      <p className="tq-overline mb-3">TARISHQ FASHION</p>
      <h1 className="font-serif text-4xl sm:text-5xl mb-8">{page.title}</h1>
      <div className="text-[#333] leading-relaxed space-y-4 text-[15px]" dangerouslySetInnerHTML={{ __html: page.content }} />
      {slug === "contact-us" && (
        <div className="grid sm:grid-cols-3 gap-4 mt-10">
          {store.phone && <a href={`tel:${store.phone.replace(/\s/g, "")}`} data-testid="contact-phone" className="tq-card p-5 text-center hover:border-[#C59B27] transition-colors"><Phone size={20} className="mx-auto mb-2 text-[#A8821B]" /><p className="text-sm font-medium">{store.phone}</p></a>}
          {store.email && <a href={`mailto:${store.email}`} data-testid="contact-email" className="tq-card p-5 text-center hover:border-[#C59B27] transition-colors"><Mail size={20} className="mx-auto mb-2 text-[#A8821B]" /><p className="text-sm font-medium break-all">{store.email}</p></a>}
          {store.whatsapp && <a href={`https://wa.me/${store.whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp" className="tq-card p-5 text-center hover:border-[#C59B27] transition-colors"><MessageCircle size={20} className="mx-auto mb-2 text-[#A8821B]" /><p className="text-sm font-medium">WhatsApp Us</p></a>}
        </div>
      )}
    </div>
  );
}
